export default {
  name: "Preparer",
  pageInfo: {
    text: "<b>This section must be completed if the preparer</b> of this application is a person other than the one identified in either Section C (employer point of contact) or D (attorney or agent) of this application.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          code: "G.1",
          machine_name: "g1_preparer_last",
          widget: "text",
          label: "Last (family) Name",
          validate: [
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the last (family) name of the person preparing this application by or on behalf of the employer.",
        },
        {
          code: "G.2",
          machine_name: "g2_preparer_first",
          widget: "text",
          label: "First (given) Name",
          validate: [
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the first (given) name of the person preparing this application by or on behalf of the employer.",
        },
        {
          code: "G.3",
          machine_name: "g3_preparer_middle",
          widget: "text",
          label: "Middle Initial",
          maxLength: 35,
          tooltip:
            "If applicable, enter the middle initial of the person preparing this application by or on behalf of the employer.",
        },
        {
          code: "G.4",
          machine_name: "g4_preparer_fein",
          widget: "text",
          label: "Law Firm/Business FEIN",
          validate: [
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
          ],
          parse: "fein",
          maxLength: 10,
          tooltip:
            "Enter the Firm/Business FEIN of the person preparing this application by or on behalf of the employer.",
        },
        {
          code: "G.5",
          machine_name: "g5_preparer_firm_name",
          widget: "text",
          label: "Law Firm/Business Name",
          validate: [
            {
              minLength: 5,
              message:
                "Law Firm/Business Name must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip:
            "Enter the Firm/Business name of the person preparing this application by or on behalf of the employer.",
        },
        {
          code: "G.6",
          machine_name: "g6_preparer_email",
          widget: "text",
          label: "Business Email Address",
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 55,
          tooltip:
            "Enter the business email address of the person preparing this application by or on behalf of the employer. Format must be <a href='' target='_blank'>name@emailaddress.top-leveldomain.</a>",
        },
      ],
    },
  ],
};
